/* eslint-disable default-param-last */
import _ from 'lodash';

import AppState from '../appState';
import DEFAULTS from '../configs/records';
import filtersUtils from './filters';

export default {
  _prepareGetRecordsArgs(
    catalogId,
    sceneId,
    request = {},
    viewMode = 'table',
    filters = [],
    sortParams,
    actionParams = {},
    abortCurrentGET,
  ) {
    if (!sceneId) {
      throw new Error('Undefined sceneId for request records!');
    }

    // sorting
    sortParams = sortParams || this.getSortParams(catalogId, viewMode);
    request = _.cloneDeep(request);
    request = Object.assign(request, sortParams);

    // search text
    request.searchText = AppState.getSearchText(sceneId);

    // filter by new messages
    const filterNewMessages = AppState.getFilterNewMessagess(sceneId);
    if (filterNewMessages) {
      request.filterNewMessages = filterNewMessages;
    }

    // limit of records
    request.limit = request.limit || DEFAULTS.RECORDS_LIMIT[viewMode];

    const { viewId = 0 } = request;
    const filtersChanged = AppState.getIn(['scenes', sceneId, 'views', viewId, 'filtersChanged']);

    /* поправить */
    const filtersFromView = this.getFilterParams(sceneId, viewId) || []; // фильтры вида
    const filtersFromScene = this.getAdditionalFilterParams(sceneId) || []; // фильтры ("data", "filters") // помоему нигде не используются

    const requestFilters = this.prepareRequestFilters(request.filters, catalogId);
    let allFilters = requestFilters || [];

    if (filtersFromScene) {  // помоему нигде не используются
      const sceneFiltersPlain =
        filtersFromScene && typeof filtersFromScene.toJS === 'function' ? filtersFromScene.toJS() : filtersFromScene;
      allFilters = _.concat(allFilters, sceneFiltersPlain || []);
    }
    if (filters) {
      let filtersPlain = filters && typeof filters.toJS === 'function' ? filters.toJS() : filters;
      // View filters may come as object by fieldId ({ "2": [{ value }] }). API expects [{ fieldId, value }, ...].
      if (filtersPlain && !Array.isArray(filtersPlain) && _.isPlainObject(filtersPlain)) {
        filtersPlain = this.prepareRequestFilters(filtersPlain, catalogId) || [];
      }
      allFilters = _.concat(allFilters, Array.isArray(filtersPlain) ? filtersPlain : [filtersPlain]);
    }
    if (filtersChanged) {
      const viewFiltersPlain =
        filtersFromView && typeof filtersFromView.toJS === 'function' ? filtersFromView.toJS() : filtersFromView;
      allFilters = _.concat(allFilters, viewFiltersPlain || []);
    }

    if (allFilters) {
      request.filters = allFilters;
    }

    if (viewId === '0' || viewId === '$new' || filtersChanged) {
      delete request.viewId; // удаление вида (потому что сервер не знает о 0 и "$new" видах)
    }

    // Передаём viewMode в actionParams для изоляции данных разных представлений
    return [{ catalogId }, request, { sceneId, viewMode, ...actionParams }, abortCurrentGET];
  },

  getSortParams(catalogId, viewMode = 'table') {
    const sortingRecordSetting = AppState.getIn([
      'userSettings',
      'catalogs',
      catalogId,
      'viewMode',
      viewMode,
      'sortingRecords',
    ]);
    let sortField = sortingRecordSetting && sortingRecordSetting.get('sortField');
    let sortType = sortingRecordSetting && sortingRecordSetting.get('sortType');

    // check if sort field exists in catalog
    if (sortField && sortField != 'id') {
      const catalogFields = AppState.getIn(['catalogs', catalogId, 'fields']);
      if (!catalogFields.find((field) => field.get('id') == sortField)) {
        sortField = undefined;
      }
    }

    // set dafault sorting
    if (!sortField) {
      sortField = 'id';
      sortType = -1;
    }

    return { sortField, sortType };
  },

  prepareRequestFilters(filters, catalogId) {
    const catalogFields = AppState.getIn(['catalogs', catalogId, 'fields']);
    return filters && filtersUtils.getFiltersForRequest(filters, catalogFields);
  },

  getFilterParams(sceneId, viewId) {
    const filters = AppState.getFiltersForRequest({ sceneId, viewId });
    return filters;
  },

  getAdditionalFilterParams(sceneId) {
    const filters = AppState.getFiltersForRequest({ sceneId });
    return filters;
  },
};
